import React, { useEffect, useState } from 'react';
import { getClientReminderSettingsAsync, updateClientReminderSettingsAsync } from '../../../Services/AdminService';
import { showToast } from '../../../Infrastructure/Notifications/ToastrConfig';

const ClientAutomation = ({ clientId, clientName }) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [remindersEnabled, setRemindersEnabled] = useState(false);

    useEffect(() => {
        const loadAutomationSettings = async () => {
            setLoading(true);
            try {
                const response = await getClientReminderSettingsAsync(clientId);
                const settings = response?.settings || response || {};
                setRemindersEnabled(Boolean(settings.isEnabled));
            } catch (error) {
                console.error('Failed to load client automation settings', error);
                showToast(false, 'Failed to load reminders setting');
            } finally {
                setLoading(false);
            }
        };

        if (clientId) {
            loadAutomationSettings();
        }
    }, [clientId]);

    const handleToggle = async evt => {
        const nextValue = evt.target.checked;
        setRemindersEnabled(nextValue);
        setSaving(true);

        try {
            const response = await updateClientReminderSettingsAsync({
                clientId,
                isEnabled: nextValue
            });

            if (response?.success === false) {
                throw new Error(response?.message || 'Failed to update reminders');
            }

            showToast(true, `${clientName || 'Client'} reminders ${nextValue ? 'enabled' : 'disabled'}`);
        } catch (error) {
            console.error('Failed to update client reminders', error);
            setRemindersEnabled(!nextValue);
            showToast(false, 'Failed to update reminders setting');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="alert alert-info mb-0">Loading reminders setting...</div>;
    }

    return (
        <div>
            <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="mr-3 mb-3 mb-md-0">
                    <h6 className="mb-1">Automated learner reminders</h6>
                    <p className="text-muted mb-0">Turn client reminders on or off for this client.</p>
                </div>
                <div className="custom-control custom-switch">
                    <input
                        type="checkbox"
                        className="custom-control-input"
                        id={`client-reminders-${clientId}`}
                        checked={remindersEnabled}
                        onChange={handleToggle}
                        disabled={saving}
                    />
                    <label className="custom-control-label" htmlFor={`client-reminders-${clientId}`}>
                        {saving ? 'Saving...' : (remindersEnabled ? 'Enabled' : 'Disabled')}
                    </label>
                </div>
            </div>

            <div className="alert alert-light border mt-3 mb-0">
                <strong>Reminder note</strong>
                <ul className="mb-0 mt-2 pl-3">
                    <li>Schedule: Hardcoded to run every Monday at 10:00 AM UTC.</li>
                    <li>Who gets them: learners who were created in the last 2 months, have incomplete coursework, have not received a reminder in the last 3 days, and belong to a client where ClientReminderConfiguration.IsEnabled = true.</li>
                </ul>
            </div>
        </div>
    );
};

export default ClientAutomation;